import { combineReducers } from "@reduxjs/toolkit";
import mfaReducer from "../../modules/MFA/redux/reducer";
import recoverPasswordReducer from "../../modules/RecoverPassword/redux/reducer";
var rootReducer = combineReducers({
    mfa: mfaReducer,
    recoverPassword: recoverPasswordReducer,
});
export default rootReducer;
